module.exports = __webpack_public_path__ + "img/camion-des-deboucheurs.7a59288.jpeg";